import { TooltipV2 } from '@cimplico/components';
import { QuestionMarkCircleIcon } from '@heroicons/react/24/solid';

type HelpIconProps = {
    message: string;
    size?: 'xs' | 'sm' | 'md';
};

function HelpIcon({ message, size = 'md' }: HelpIconProps): JSX.Element {
    const sizing = size === 'md' ? 'h-5 w-5' : size === 'sm' ? 'h-4 w-4' : 'h-3 w-3';
    return (
        <TooltipV2 message={message}>
            <QuestionMarkCircleIcon className={`${sizing} text-gray-500`} />
        </TooltipV2>
    );
}
export default HelpIcon;
